<template>
  <h2 class="mb-4 sm:text-4xl text-2xl sm:text-center font-medium">
    {{ $t("contact.title") }}
  </h2>
  <p
    class="mb-5 lg:mb-10 font-light sm:text-base text-sm sm:text-center whitespace-pre-line"
  >
    {{ $t("contact.description") }}
  </p>
</template>
